import React from 'react';
import { Col, IconAlertCircleFill, IconSize, Row } from '@amzn/atoz-web';
import { Text } from '@amzn/atoz-web/Text';
import { useTranslation } from 'react-i18next';
import { getPayModifierCategoryStr, getPremiumPayCategoryStr } from '../../DropMergedShiftModalContent/utils';
import { formattedCurrency } from '../../../../utils';
export var PremiumPayMessages = function (_a) {
    var _b, _c;
    var dropOpportunity = _a.dropOpportunity, fromPayBreakdown = _a.fromPayBreakdown;
    var t = useTranslation().t;
    var premiumPays = (_b = dropOpportunity.payBreakdown) === null || _b === void 0 ? void 0 : _b.premiums;
    var payModifiers = (_c = dropOpportunity.incentivePay) === null || _c === void 0 ? void 0 : _c.payModifiers;
    var showPremiumPays = fromPayBreakdown && !!premiumPays;
    var showPayModifiers = !fromPayBreakdown && !!payModifiers;
    return (React.createElement(Col, { style: { whiteSpace: 'pre-wrap' } },
        React.createElement(Row, { margin: { top: 'S300' }, backgroundColor: 'lightblue' },
            React.createElement(Text, { dataTestId: "merged-shift-premium-pay-applied-title-text", fontSize: 'T100', fontWeight: 'light' }, t('shift_management_features_MultipleDropShiftModal_premium_pay_applied')),
            showPremiumPays &&
                premiumPays.map(function (premium, i) {
                    return (React.createElement(Row, { key: i, dataTestId: "merged-shift-premium-pay-category-str-".concat(i) },
                        React.createElement(Text, { fontSize: 'T100', fontWeight: 'bold' },
                            formattedCurrency(premium.hourlyCompensation),
                            ' '),
                        React.createElement(Text, { fontSize: 'T100', fontWeight: 'light' }, getPremiumPayCategoryStr(premium)),
                        i < premiumPays.length - 1 && (React.createElement(Text, { fontSize: 'T100', fontWeight: 'light' }, ',  '))));
                }),
            showPayModifiers &&
                payModifiers.map(function (payModifier, i) {
                    return (React.createElement(Row, { key: i, dataTestId: "merged-shift-premium-pay-modifier-category-str-".concat(i) },
                        React.createElement(Text, { fontSize: 'T100', fontWeight: 'bold' },
                            formattedCurrency(payModifier.hourlyAdditionalCompensation),
                            ' '),
                        React.createElement(Text, { fontSize: 'T100', fontWeight: 'light' }, getPayModifierCategoryStr(payModifier)),
                        i < payModifiers.length - 1 && (React.createElement(Text, { fontSize: 'T100', fontWeight: 'light' }, ',  '))));
                })),
        React.createElement(Row, { dataTestId: 'merge-shift-confirm-drop-premium-pay-disclaimer', margin: { top: 'S100' } },
            React.createElement(Row, { margin: { right: 'S200', top: 'S100' }, alignSelf: "baseline" },
                React.createElement(IconAlertCircleFill, { size: IconSize.ExtraSmall, color: 'neutral50' })),
            React.createElement(Text, { margin: { right: 'S200' }, fontWeight: 'light', fontSize: 'T100' }, t('shift_management_features_MultipleDropShiftModal_premium_pay_disclaimer')))));
};
